import { parseISO, format } from "date-fns";

export function toDateSafe(value?: string | Date | null): Date | null {
  if (!value) return null;
  try {
    const d = typeof value === "string" ? parseISO(value) : new Date(value as Date);
    if (!isNaN(d.getTime())) return d;
  } catch (e) {
    // fallthrough
  }
  try {
    const d2 = new Date(value as any);
    return isNaN(d2.getTime()) ? null : d2;
  } catch {
    return null;
  }
}

export function formatSafe(value: string | Date | null | undefined, fmt: string, fallback = "—"): string {
  const d = toDateSafe(value);
  return d ? format(d, fmt) : fallback;
}

/**
 * Format a date/datetime string for display.
 * If the value is date-only (no time component), omits the time to avoid showing a misleading "12:00 AM".
 */
export function formatDateOrDatetime(
  value: string | Date | null | undefined,
  fallback = "—",
): string {
  if (!value) return fallback;
  const isDateOnly = typeof value === "string" && /^\d{4}-\d{2}-\d{2}$/.test(value);
  return formatSafe(value, isDateOnly ? "MMM d" : "MMM d, h:mm a", fallback);
}

export default { toDateSafe, formatSafe };
